import React from 'react';
import { Translate, TranslateContext } from 'core/translate';
import { SvgIcon } from 'core/icons';
import Date from '../../common/intl/Date';

const ENTER = 13;

class ShareDropDown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false
    };
    this.toggleOpen = this.toggleOpen.bind(this);
  }

  toggleOpen() {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen
    }));
  }

  onSelect(config) {
    this.setState({ isOpen: false });
    this.props.onSelect(config);
  }

  render() {
    const { isOpen } = this.state;
    const { configs, selected } = this.props;

    return (
      <TranslateContext.Consumer>
        {translate => {
          const title = translate('component.sendsave.your.saved.vehicle');
          const header = translate('component.sendsave.other.vehicles');
          const analyticsKey = `${title}:${header}`;

          const options = configs.map(config => (
            <li
              key={config.ss}
              onClick={() => this.onSelect(config)}
              onKeyPress={event => {
                if (event.which === ENTER) {
                  this.onSelect(config);
                }
              }}
              className={`save-send__dropdown-item stat-text-link ${
                config === selected ? 'active' : ''
              }`}
              data-dtm={analyticsKey}
              data-dtm2={config.title}
              role="button"
              tabIndex="0">
              <span className="save-send__dropdown-saved">
                <Translate
                  value="component.price.info.carline.title"
                  bodyStyleTitle={config.bodyStyleTitle}
                  year={config.modelyear}
                />
              </span>
              <span className="save-send__dropdown-date">
                <Translate value="saved" />{' '}
                <Date value={config._lastModified} />
              </span>
            </li>
          ));

          return (
            <div className="save-send__dropdown-container">
              <ul>
                <li>
                  <button
                    className="save-send__dropdown-header stat-dropdown"
                    data-dtm={analyticsKey}
                    onClick={this.toggleOpen}>
                    <SvgIcon name="heart" />
                    <span className="save-send__text">{header}</span>
                    <SvgIcon
                      name="chevron-up"
                      className={`save-send__dropdown-icon ${
                        isOpen ? '' : 'hidden'
                      }`}
                    />
                    <SvgIcon
                      name="chevron-down"
                      className={`save-send__dropdown-icon ${
                        isOpen ? 'hidden' : ''
                      }`}
                    />
                  </button>
                </li>
              </ul>
              {isOpen ? (
                <ul className="save-send__dropdown save-send__dropdown--open">
                  {options}
                </ul>
              ) : null}
            </div>
          );
        }}
      </TranslateContext.Consumer>
    );
  }
}

export default ShareDropDown;
